import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MybusinessNeedOfferDetail} from 'components/my-business';
import title from 'constants/TitlePages.js';
import {BusinessLayout} from 'components/layouts/business';
import {Demands} from 'api';
import {toastr} from 'react-redux-toastr';

class MybusinessNeedOfferDetailPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.MybusinessNeedOfferDetailPage;

    this.setState({isLoading: true});
    Demands.actions.demand.request({
      id: this.props.match.params.id,
      filter: {
        include: ['user', 'categories']
      }
    }).then(response => {
      this.setState({
        isLoading: false,
        demand: response.data
      });
    }).catch((error) => {
      console.log(error)
      this.setState({isLoading: false});
      toastr.error('Lỗi!', 'Không tìm thấy nhu cầu này');
    });

  }

  render() {
    return (
      <MasterLayout>
        <BusinessLayout active='need-offer'>
          {this.state.demand &&
            <MybusinessNeedOfferDetail {...this.state.demand}/>
          }
        </BusinessLayout>
      </MasterLayout>
    );
  }
}

export default MybusinessNeedOfferDetailPage;



// WEBPACK FOOTER //
// ./pages/need-offer/MybusinessNeedOfferDetailPage.jsx